export const site = {
  name: "Campus EMJC",
  longName: "Escuela Municipal de Jóvenes Científicos",
  tagline: "Cada día un científico diferente.",
  description:
    "Campamentos, talleres y ferias donde niños y niñas de Extremadura descubren la ciencia jugando, experimentando y trabajando en equipo.",
  email: "camptecnologicoemjc@unex.es",
  university: "Universidad de Extremadura",
  ages: "8–12 años",
  social: {
    facebook: {
      label: "emjc Jóvenes-Científicos",
      url: "https://www.facebook.com/profile.php?id=100071256989762",
    },
    instagram: {
      label: "@emjc_uex",
      url: "https://www.instagram.com/emjc_uex/",
    },
  },
};
